import { StateType, ActionType } from "../../types/contextType";

const Reducer = (state: StateType, action: ActionType) => {
  switch (action.type) {
    case "UPDATE_USER":
      return {
        ...state,
        user: action.payload,
        authenticated: true,
      };
    case "LOGOUT_USER":
      return {
        ...state,
        user: undefined,
        authenticated: false,
        filter: {cep: null, status: null, locations: null, unassigned: null},
      };
    case "LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "UPDATE_EXTERNAL_URLS":
      return {
        ...state,
        externalUrls: action.payload,
      };
    case "FILTER":
      return {
        ...state,
        filter: action.payload,
      };
    default:
      return state;
  }
};

export default Reducer;
